import styled from 'styled-components';

export const StyledCardHeader = styled.header`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr auto;
  grid-row-gap: 0.5rem;
  grid-column-gap: 0.5rem;
  .arrowButton {
    background: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  .label {
    justify-self: center;
    display: flex;
    align-items: center;
    margin: 0;
    gap: 0.25rem;
  }
  .tagsRow {
    grid-column: span 3;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
  }
  @media (max-width: 576px) {
    display: flex;
    flex-direction: column;
  }
`;
